import React from 'react'

/**
 * CallLogsHeader Component
 * Canonical Top Canopy matching the Attendance module design language.
 * Displays module eyebrow, 3xl bold title, audit description, and total log count pill.
 */
export default function CallLogsHeader({ totalLogsCount = 0, onRefresh, loading = false }) {
  return (
    <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
          Telephony &amp; Voice
        </p>
        <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
          Call Audit Logs &amp; Recording History
        </h1>
        <p className="mt-0.5 text-xs text-on-surface-variant font-medium">
          Complete audit trail of all inbound and outbound calls, Exotel voice recordings, and linked ERP job entries.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2.5 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-4 py-2 shadow-xs">
          <span className="text-xs font-bold text-on-surface">Total Logs:</span>
          <span className="px-2.5 py-0.5 rounded-xl bg-primary/10 text-primary border border-primary/20 text-xs font-extrabold">
            {totalLogsCount}
          </span>
          {onRefresh && (
            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              title="Refresh logs"
              className="w-7 h-7 ml-1 rounded-xl bg-surface-container-low border border-outline-variant/30 text-on-surface-variant hover:bg-surface-container-highest hover:text-primary flex items-center justify-center transition-colors disabled:opacity-50 cursor-pointer"
            >
              <span className={`material-symbols-outlined text-sm ${loading ? 'animate-spin' : ''}`}>
                refresh
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  )
}
